export enum ErrorCode {
    disabled = 'order.disabled',
    unauthenticated = 'user.unauthenticated'
}
